import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, RelationId} from "typeorm";
import {Season} from "@/modules/season/entity";
import {Min} from "class-validator";
import {BaseEntity} from "@/modules/base/entity";
import {Team} from "@/modules/team/entity";
import {LeagueDivision} from "@/modules/competitions/entity/LeagueDivision";

@Entity()
export class TableStatistics extends BaseEntity {
  @ManyToOne(() => Season)
  season: Relation<Season>;

  @ManyToOne(() => Team)
  team: Relation<Team>;

  @RelationId((m: TableStatistics) => m.team)
  teamId: number;

  @ManyToOne(() => LeagueDivision, division => division.stats)
  division: Relation<LeagueDivision>;
  
  @RelationId((m: TableStatistics) => m.division)
  divisionId: number;

  @Column({type: "integer", unsigned: true, nullable: true})
  @Min(1)
  rank?: number;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  matches = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  wins = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  draws = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  loses = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  goals = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  goals_against = 0;

  @Column({type: "integer", unsigned: true})
  @Min(0)
  points = 0;

  get goalsDiff() {
    return this.goals - this.goals_against;
  }
}
